module.exports = __webpack_public_path__ + "media/images/icons/facebook_logo-0cb70ae2abcc6a7ce7c6638528996dd6.svg";